export function accessoriesSimpleSlider(): void {
    const simpleSlider = document.querySelectorAll<HTMLElement>('.accessories-simple-slider');

    if (simpleSlider.length === 0) return;

    simpleSlider.forEach((slides) => {
        const imageEl = slides.querySelector<HTMLElement>('.simple-slider-image');
        const thumbnailEl = slides.querySelector<HTMLElement>('.simple-slider-thumbnails');

        if (!imageEl || !thumbnailEl) return;

        const imageItems = imageEl.querySelectorAll<HTMLElement>('.simple-slider-image-item');
        const thumbnailItems = thumbnailEl.querySelectorAll<HTMLButtonElement>('.simple-slider-thumbnail-item');

        if (imageItems.length === 0 || thumbnailItems.length === 0) return;

        imageEl.style.position = 'relative';
        imageEl.style.overflow = 'hidden';
        imageEl.style.aspectRatio = '3 / 2';

        imageItems.forEach((item) => {
            item.style.position = 'absolute';
            item.style.inset = '0';
            item.style.width = '100%';
            item.style.height = '100%';
        });

        let currentIndex = 0;
        let touchStartX = 0;
        let touchStartY = 0;
        const swipeThreshold = 30;

        const showSlide = (index: number, animate = true) => {
            const normalizedIndex = (index + imageItems.length) % imageItems.length;
            currentIndex = normalizedIndex;

            imageItems.forEach((item, itemIndex) => {
                const isActive = itemIndex === normalizedIndex;

                if (!animate) {
                    item.style.transition = 'none';
                    item.style.opacity = isActive ? '1' : '0';
                    item.style.display = isActive ? 'block' : 'none';
                    item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
                    return;
                }

                item.style.transition = 'opacity 0.2s ease';

                if (isActive) {
                    item.style.display = 'block';
                    item.setAttribute('aria-hidden', 'false');
                    item.style.opacity = '0';

                    requestAnimationFrame(() => {
                        item.style.opacity = '1';
                    });

                    return;
                }

                item.setAttribute('aria-hidden', 'true');
                item.style.opacity = '0';

                item.addEventListener('transitionend', (event) => {
                    if (event.propertyName !== 'opacity') return;
                    if (item.getAttribute('aria-hidden') !== 'true') return;

                    item.style.display = 'none';
                }, { once: true });
            });

            thumbnailItems.forEach((item, itemIndex) => {
                const isActive = itemIndex === normalizedIndex;

                item.setAttribute('aria-current', isActive ? 'true' : 'false');
            });
        };

        showSlide(0, false);

        thumbnailItems.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                showSlide(index);
            });
        });

        imageEl.addEventListener('touchstart', (event) => {
            const touch = event.changedTouches[0];

            touchStartX = touch.clientX;
            touchStartY = touch.clientY;
        }, { passive: true });

        imageEl.addEventListener('touchend', (event) => {
            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - touchStartX;
            const deltaY = touch.clientY - touchStartY;

            if (Math.abs(deltaX) <= Math.abs(deltaY) || Math.abs(deltaX) < swipeThreshold) {
                return;
            }

            if (deltaX < 0) {
                showSlide(currentIndex + 1);
                return;
            }

            showSlide(currentIndex - 1);
        }, { passive: true });
    });
}
